// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs[data-v-35e9f352]{display:flex;flex-wrap:wrap;margin-bottom:10px}.breadcrumbs__item[data-v-35e9f352]{margin-right:.3em}.breadcrumbs__item[data-v-35e9f352]:not(:first-child):before{content:\"/\";margin-right:.3em}.breadcrumbs__link[data-v-35e9f352]{color:var(--body-color)}@media(max-width:991.98px){.breadcrumbs[data-v-35e9f352]{font-size:14px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
